<template>
  <view-toolbox
    title="Map List Item Properties"
    back-title="Map List"
    :back-count="8"
  >
    <DetailProperties
      :item="item"
    />
  </view-toolbox>
</template>

<script>
import ViewToolbox from '@/components/views/ViewToolbox';
import ViewUtils from '@/components/views/ViewUtils';
import DetailProperties from '@/components/views/shared/DetailProperties';

export default {
  name: 'DetailsItemProperties',
  components: {
    ViewToolbox,
    DetailProperties,
  },
  mixins: [
    ViewUtils,
  ],
  computed: {
    item() {
      const {
        columnIndex,
        groupIndex,
        itemIndex,
        layoutIndex,
      } = this.$route.params;

      return this
        .viewRaw
        ?.details
        ?.columns[layoutIndex]
        ?.groups[groupIndex]
        ?.columns[columnIndex][itemIndex];
    },
  },
};
</script>
